export default "__VITE_ASSET__379c9e42__"